import React, { useState } from "react";
import UserLayout from "../../components/user/UserLayout";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { FaBook } from "react-icons/fa";

const abbreviationsData = [
  { abbr: "AD", meaning: "Ağızdan" },
  { abbr: "PR", meaning: "Rektal yoldan" },
  { abbr: "IM", meaning: "Kas içine uygulama" },
  { abbr: "IV", meaning: "Damar içine uygulama" },
  { abbr: "PO", meaning: "Ağızdan uygulama" },
  { abbr: "BID", meaning: "Günde iki kez" },
  { abbr: "TID", meaning: "Günde üç kez" },
  { abbr: "QID", meaning: "Günde dört kez" },
  { abbr: "UNG", meaning: "Merhem" },
  { abbr: "SOL", meaning: "Solüsyon" },
  { abbr: "SUSP", meaning: "Süspansiyon" },
  { abbr: "COMP", meaning: "Komprime / Tablet" },
  { abbr: "S.C.", meaning: "Deri altı uygulama" },
  { abbr: "NPO", meaning: "Ağızdan hiçbir şey alınmaması" },
  { abbr: "STAT", meaning: "Acil uygulama" },
  { abbr: "PRN", meaning: "Gerektiğinde" },
  { abbr: "QHS", meaning: "Her gece yatmadan önce" },
  { abbr: "Q4H", meaning: "4 saatte bir" },
  { abbr: "Gtt", meaning: "Damla" },
];

const AbbreviationPage = () => {
  const [search, setSearch] = useState("");
  const [filterLetter, setFilterLetter] = useState("");

  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const filteredData = abbreviationsData.filter((item) => {
    const matchSearch =
      item.abbr.toLowerCase().includes(search.toLowerCase()) ||
      item.meaning.toLowerCase().includes(search.toLowerCase());

    const matchLetter = filterLetter
      ? item.abbr.startsWith(filterLetter)
      : true;

    return matchSearch && matchLetter;
  });

  return (
    <UserLayout>
      <h2 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
        Kısaltmalar Sözlüğü
      </h2>

      <p className="text-muted mb-4">
        Majistral ve medikal alanda sık kullanılan kısaltmaların anlamlarını
        kolayca bulabileceğiniz bir sözlüktür.
      </p>

      {/* 🔍 Arama Kutusu */}
      <Form.Control
        type="text"
        placeholder="Kısaltma veya anlam ara..."
        className="mb-3"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* 🔤 Harf Filtreleme */}
      <div className="d-flex flex-wrap gap-2 mb-4">
        {letters.map((letter) => (
          <Button
            key={letter}
            size="sm"
            variant={filterLetter === letter ? "primary" : "outline-primary"}
            className="px-3"
            onClick={() =>
              setFilterLetter((prev) => (prev === letter ? "" : letter))
            }
          >
            {letter}
          </Button>
        ))}
      </div>

      {/* 📘 Sonuçlar */}
      <Row className="g-3">
        {filteredData.length === 0 && (
          <p className="text-muted">Sonuç bulunamadı.</p>
        )}

        {filteredData.map((item, index) => (
          <Col md={4} key={index}>
            <Card className="p-3 shadow-sm rounded-4 h-100">
              <h5 className="fw-bold d-flex align-items-center" style={{ color: "#2D8A7A" }}>
                <FaBook className="me-2" /> {item.abbr}
              </h5>
              <p className="text-muted mb-0">{item.meaning}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </UserLayout>
  );
};

export default AbbreviationPage;
